module.exports = __webpack_public_path__ + "img/associate.d939af71.png";